import { JobsLanguages } from "./jobsLanguages.models";
import { JobsSkills } from "./jobsSkills.models";
import { JobsTrainings } from "./jobsTrainings.models";
import { AreaActivities } from './areaActivities.model';
import { Professions } from './professions.model';
import { Companies } from './companies.model';
import { formatDate } from '@angular/common';
import { environment } from "src/environments/environment";

export class Jobs {
  private id: number;
  private reference: string;
  private libelle: string;
  private description: string;
  private type_job: string;
  private job_level: number;
  private country: string;
  private city: string;
  private min_age: number;
  private max_age: number;
  private age_rating: number;
  private expiration_date: any;
  private years_of_experience: string;
  private years_exp_rating: number;
  private status: string;
  private job_describe_file: string;
  private areaActivities: AreaActivities;
  private professions: Professions;
  private companies: Companies;
  private jobsTrainings: Array<JobsTrainings> = [];
  private jobsLanguages: Array<JobsLanguages> = [];
  private jobsSkills: Array<JobsSkills> = [];

  constructor(JobsModel: any) {
    this.id = JobsModel.id;
    this.reference = JobsModel.reference;
    this.libelle = JobsModel.libelle;
    this.description = JobsModel.description;
    this.type_job = JobsModel.type_job;
    this.job_level = JobsModel.job_level;
    this.country = JobsModel.country;
    this.city = JobsModel.city;
    this.min_age = JobsModel.min_age;
    this.max_age = JobsModel.max_age;
    this.age_rating = JobsModel.age_rating;
    this.expiration_date = JobsModel.expiration_date;
    this.years_of_experience = JobsModel.years_of_experience;
    this.years_exp_rating = JobsModel.years_exp_rating;
    this.status = JobsModel.status;
    this.job_describe_file = JobsModel.job_describe_file;
    this.areaActivities = JobsModel.areaActivities;
    this.professions = JobsModel.professions;
    this.companies = JobsModel.companies;

    // jobsTrainings
    if (JobsModel.jobsTrainings != undefined) {
      for (let index = 0; index < JobsModel.jobsTrainings.length; index++) {
        const element = JobsModel.jobsTrainings[index];

        var jobsTrainings = new JobsTrainings(element);

        this.jobsTrainings.push(jobsTrainings);
      }
    } else {
      this.jobsTrainings = [];
    }

    // jobsLanguages
    if (JobsModel.jobsLanguages != undefined) {
      for (let index = 0; index < JobsModel.jobsLanguages.length; index++) {
        const element = JobsModel.jobsLanguages[index];

        var jobsLanguages = new JobsLanguages(element);

        this.jobsLanguages.push(jobsLanguages);
      }
    } else {
      this.jobsLanguages = [];
    }

    // jobsSkills
    if (JobsModel.jobsSkills != undefined) {
      for (let index = 0; index < JobsModel.jobsSkills.length; index++) {
        const element = JobsModel.jobsSkills[index];

        var jobsSkills = new JobsSkills(element);

        this.jobsSkills.push(jobsSkills);
      }
    } else {
      this.jobsSkills = [];
    }
  }

  getId(): number {
    return this.id;
  }

  getReference(): string {
    return this.reference;
  }

  getLibelle(): string {
    return this.libelle;
  }

  getDescription(): string {
    return this.description;
  }

  getTypeJob(): string {
    return this.type_job;
  }
  getJobLevel(): number {
    return this.job_level;
  }

  getCountry(): string {
    return this.country;
  }

  getCity(): string {
    return this.city;
  }

  getMinAge(): number {
    return this.min_age;
  }
  getMaxAge(): number {
    return this.max_age;
  }

  getAgeRating(): number {
    return this.age_rating;
  }

  getExpirationDate(): any {
    return formatDate(new Date(this.expiration_date), 'dd-MM-yyyy', 'en');
  }

  getYearOfExperience(): string {
    return this.years_of_experience;
  }
  getYearsExpRating(): number {
    return this.years_exp_rating;
  }

  getStatus(): string {
    return this.status;
  }

  public getJobDescribeFile(): string {
    return (this.job_describe_file != null && this.job_describe_file != '') ? environment.apiUrl + this.job_describe_file : this.job_describe_file;
  }

  getAreaActivity(): AreaActivities {
    return this.areaActivities;
  }

  getProfession(): Professions {
    return this.professions;
  }

  getCompany(): Companies {
    return this.companies;
  }

  getJobsTrainings(): Array<JobsTrainings> {
    return this.jobsTrainings;
  }

  getJobsLanguages(): Array<JobsLanguages> {
    return this.jobsLanguages;
  }

  getJobsSkills(): Array<JobsSkills> {
    return this.jobsSkills;
  }

}